import React from 'react';
import { Link } from '../Link';
export function TableLink(props) {
    return (React.createElement(Link, { unstyled: true, "data-table-row-action": true, "data-table-row-tabbable": true, ...props, onClick: (e) => {
            var _a;
            e.stopPropagation();
            (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
        } }));
}
//# sourceMappingURL=TableLink.js.map